var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoldericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 52,
    viewBox: "0 0 58 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.52 51.738C55.994 51.738 58 49.732 58 47.258V12.389C58 9.915 55.994 7.909 53.52 7.909H26.528L19.931 1.312C19.091 0.472 17.951 0 16.763 0H4.48C2.006 0 0 2.006 0 4.48V47.258C0 49.732 2.006 51.738 4.48 51.738H53.52Z",
    fill: "#EAFCFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldericon);
export default __webpack_public_path__ + "static/media/foldericon.023f99ea20f8d7d1442a5b835f02761c.svg";
export { ForwardRef as ReactComponent };